/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.5.15",
    versionName: "0.2.0-nightly.2026.5.15",
    versionChannel: "nightly",
    buildDate: "2026-05-15T00:33:25.780Z",
    commitHash: "69afbe077a11dcdf44af307a85eedbe4bc314352",
};
